class ProductFormSubmit extends HTMLElement {
  constructor() {
    super();

    const elements = {
      form: this.closest("form"),
      button: this.querySelector("button"),
      spinnerContainer: this.querySelector(".spinner-container")
    };

    elements.selling_plan = elements.form.querySelector("[name=selling_plan]");

    elements.button.addEventListener("click", (event) => {
      event.preventDefault();

      if (this.hasAttribute("data-variant-unchosen")) {
        elements.form.querySelector("product-form-variants")?.flagMissing();
        return;
      }

      if (elements.spinnerContainer) {
        elements.spinnerContainer.classList.add("state--loading");
      }

      const data = new FormData(elements.form);

      if (elements.selling_plan && elements.selling_plan.disabled) {
        data.set("selling_plan", "");
      }

      fetch("/cart/add.js", {
        method: "POST",
        body: data
      })
      .then(response => {
        return response.json();
      })
      .then(response => {
        document.dispatchEvent(new CustomEvent("addtocart", {
          detail: response
        }));
      })
      .catch(error => {
        console.error("ProductFormSubmitError: ", error);
      })
      .finally(() => {
        if (elements.spinnerContainer) {
          elements.spinnerContainer.classList.remove("state--loading");
        }
      });
    });
  }
}

customElements.define("product-form-submit", ProductFormSubmit);
